import { phoneNumberMF } from './features/login/phone_number';
import { otpVerifyMF } from './features/login/otp_verify';
import { emailVerifyMF } from './features/mfFetch/email_verify';
import { ROUTE } from './routes';
import { emailMF } from './features/mfFetch/enter_email';
import { panVerifyMF } from './features/mfFetch/verifyPan/pan_verify';
import { panConfirmMF } from './features/mfFetch/verifyPan/pan_confirm';
import { checkLimitMF } from './features/mfFetch/check_limit';
import { updateMobileNumberMF } from './features/mfFetch/update_phoneNo';
import { otpVerifyAuthCASMF } from './features/mfFetch/otp_CAS';
import { verificationFailedMF } from './features/mfFetch/verification_failed';
import { testPageMF } from './features/test_page';
import { kycAadharVerifyMF } from './features/kyc/kyc_aadhar_init';
import { kycAadharOTPVerifyMF } from './features/kyc/kyc_otp';
import { bankAccountVerifyMF } from './features/bankVerify/bank_account_verification';
import { bankSelectMF } from './features/bankVerify/select_bank';
import { bankAccountAddMF } from './features/bankVerify/bank_account_add';
import { bankSearchBranchMF } from './features/bankVerify/bank_search_branch';
import { kycSummaryMf } from './features/kyc/kyc_summary';
import { kycStepperMF } from './features/kyc/kyc_stepper';
import { cameraOpenMF } from './features/kyc/kyc_photo_init';
import { kycDigiLockerMF } from './features/kyc/kyc_init';
import { alertMF } from './features/popup_loader';
import { cameraCaptureMF } from './features/kyc/kyc_photo_upload';
import { splashScreenMF } from './features/spalsh_screen';
import { pledgeVerifyMF } from './features/mfPledge/pledge_verify';
import { pledgeLoadingMF } from './features/mfPledge/pledge_loading';
import { pledgeConfirmationLoadingMF } from './features/mfPledge/pledge_confirmation_loader';
import { unlockSuccessMF } from './features/mfPledge/unlock_success';
import { modifyLimitMF } from './features/mfPledge/modify_limit';
import { pledgeAmountMF } from './features/mfPledge/pledged_amount';
import { modifyPledgeMF } from './features/mfPledge/modify_pledged_amount';
import { dashboardMF } from './features/afterUnlock/dashboard';
import { withdraw_amountMF } from './features/afterUnlock/withdraw_amount';
import { withdrawalOtpMF } from './features/afterUnlock/withdrawal_otp';
import { withdrawalSuccessMF } from './features/afterUnlock/withdrawal_success';
import { repaymentMF } from './features/afterUnlock/repayment';
import { loanRepaymentMF } from './features/loanAgreement/loan_repayment';
import { loanWebViewMF } from './features/loanAgreement/loan_webView';
import { loanAutoPayMF } from './features/loanAgreement/loan_autopay';
import { agreementWebViewMF } from './features/loanAgreement/agreement_webview';
import { loanAgreementMF } from './features/loanAgreement/loan_agreement';
import { accountDetailsMF } from './features/profile/account_details';
import { contactUsMF } from './features/profile/contact_us';
import { myProfileMF } from './features/profile/my_profile';
import { faqMF } from './features/profile/faq';
import { aboutUsMF } from './features/profile/about_us';
import { faqDetailsMF } from './features/profile/faq_details';
import { carousalPageMF } from './features/carousal/';
import { landingPageMF } from './features/landing';
import { privacyPolicyMF } from './features/privacy_policy';
import { kycAdditionalDetailsMF } from './features/kyc/kyc_additional_details';
import { DistributorClientListMF } from './features/DistributorClientList/ClientList';
import { checkingLimitMf } from './features/mfFetch/checking_limit';
import { portfolioReadOnlyMF } from './features/mfPledge/portfolio_readonly';
import { verificationFailedMFNew } from './features/mfFetch/verification_failed_new';
import { unlockLimitLandingMFV2 } from './features/mfPledge/unlock_limit_landing_V2';
import { setCreditLimitMf } from './features/mfPledge/set_credit_limit';
import { pledgeConfirmationMFV2 } from './features/mfPledge/pledge_confirmation_V2';
import { portfolioMFV2 } from './features/mfPledge/portfolio_V2';
import { updateSliderAmountMF } from './features/mfPledge/update_slider_amount';
import { kycDocumentUploadPOAMF } from './features/kyc/kyc_doc_upload_POA';
import { kycDocumentUploadPOIMF } from './features/kyc/kyc_doc_upload_POI';
import { loanAgreementPollingMF } from './features/loanAgreement/loan_agreement_poll';
import { selectSourceMF } from './features/mfFetch/select_source';
import { manageLimitMF } from './features/afterUnlock/manage_limit';
import { setCreditLimitMf2 } from './features/mfPledge/set_credit_limit_v2';
import { portfoliofromRTAMf } from './features/mfPledge/portfoliofromRTA';
import { distBankAccountAddMF } from './features/bankDetailsDistributor/bank_account_add';
import { distBankSearchBranchMF } from './features/bankDetailsDistributor/bank_search_branch';
import { distBankSelectMF } from './features/bankDetailsDistributor/select_bank';
import { distributorPortfolioMF } from './features/fetchDistributorPortfolio';
import { portfolioStartMF } from './features/selectPortfolio/porftfolioStart';
import { selectDistributorPortfolioMF } from './features/selectPortfolio/selectDistributorPortfolio';
import { investorMF } from './features/investor';
import { distBasicDetailsMF } from './features/Dist_basicDetails/basicDetailsInfo';
import { kycDocumentUploadMF } from './features/kyc/kyc_document_upload';
import { nameMF } from './features/enter_name';
import { detailsConfirmMF } from './features/Dist_basicDetails/details_confirm';
import { basicDetailsStartMF } from './features/Dist_basicDetails/basicDetailsStart';
import { DistributorClientListStepperMF } from './features/DistributorClientList/ClientListStepper';
import { introPageMF } from './features/introPage';
import { PartnerWebDashboardPageMF } from './partnerWeb_Features/partnerWeb_Dashboard';
import { PartnerReferredPartnerMF } from './partnerWeb_Features/referredPartner/indexMF';
import { PartnerActiveCustomerMF } from './partnerWeb_Features/activeCustomer/indexMf';
import { PartnerLeadsMF } from './partnerWeb_Features/leads/indexMF';
import { voltAppMF } from "./partnerWeb_Features/volt-App";
import { partnerLedJourney } from "./features/plj";
import { digioAgreementSignMF } from "./features/loanAgreement/digio_agreement_sign";
import { digioMandateSignMF } from "./features/loanAgreement/digio_mandate_sign";
import { registerLeadsMF } from "./partnerWeb_Features/registerLeads";
import { registerLeadsSuccessMF } from "./partnerWeb_Features/registerLeadsSuccess";
import { paymentStart } from "./features/payment/paymentStart";
import { paymentCallback } from "./features/payment/paymentCallback";
import { kycDocumentUploadPOIManualMF } from './features/kyc/kyc_doc_upload_POI_manual';
import { kycDocumentUploadPOAManualMF } from './features/kyc/kyc_doc_upload_POA_manual';
import { kycDigioMf } from './features/kyc/kyc_digio_base';
import { kycDocumentsUploadBaseMF } from './features/kyc/kyc_doc_upload_base';
import { coBorrowerPan } from './features/kyc/kyc_co_borrower/co_borrower_pan';
import { kycCoBorrowerAdditionalDetailsMF } from './features/kyc/kyc_co_borrower/co_borrower_additional_details';
import { coBorrowerKYCSummaryMf } from './features/kyc/kyc_co_borrower/co_borrower_kyc_summary';
import { coBorrowerKYCSummaryConfirmMf } from './features/kyc/kyc_co_borrower/co_borrower_kyc_summary_confirm';
import { coBorrowerLandingMF } from './features/kyc/kyc_co_borrower/co_borrower_landing';
import { coBorrowerKYCDocumentsUploadBaseMF } from './features/kyc/kyc_co_borrower/co_borrower_doc_upload_base';
import { coBorrowerDocumentUploadPOAManualMF } from './features/kyc/kyc_co_borrower/co_borrower_doc_upload_POA_manual';
import { coBorrowerPANConfirmMF } from './features/kyc/kyc_co_borrower/co_borrower_pan_confirm_name';
import { coBorrowerDocumentUploadPOIManualMF } from './features/kyc/kyc_co_borrower/co_borrower_doc_upload_POI_manual';
import { paymentLoader } from "./features/payment/paymentLoader";
import { jointHolderNotifyMf } from './features/mfPledge/joint_holder_notify';
import { askMutualFundMF } from "./features/AskMutualFund/askMutualFund";
import { noMutualFundMF } from "./features/AskMutualFund/noMutualFundInstruction";
import { digioModel } from "./features/DigioModal";
import { PartnerSignUpPage } from "./partnerWeb_Features/partnerSignUp";
import { EmpanelSuccessMF } from "./partnerWeb_Features/empanelSuccess";
import { InviteClientMF } from "./partnerWeb_Features/inviteClient";
import { PartnerLogoutMF } from "./partnerWeb_Features/partnerLogout";
import { PartnerMobSideNav } from "./partnerWeb_Features/partnerMobMenu";
import { collateralNav } from "./partnerWeb_Features/collateral";
import { demoVideosNav } from "./partnerWeb_Features/demoVideos";
import { myAccountMF } from "./partnerWeb_Features/accountDetails";
import { partnerViewDetailLeads } from "./partnerWeb_Features/partnerViewDetailLeads";
import { askMutualFundOldMf } from "./features/AskMutualFund/askForMutualFundOld";
import { platformDashboardMF } from "./platformDashboard/dashboard";
import { platformLeadsMF } from "./platformDashboard/leads/indexMF";
import { platformActiveCustomersMF } from "./platformDashboard/activeCustomers/indexMf";
import { platformLinkedPartnersMF } from "./platformDashboard/linkedPartners/indexMF";
import { platformSignupMF } from "./platformDashboard/signup";
import { platformviewDetailsMF } from "./platformDashboard/viewDetails";
import { platformLogOutMF } from "./platformDashboard/logout";
import { MarketingLeadsMF } from "./marketingFeature/MarketingLeads";
import { MarketingLeadOtp } from "./marketingFeature/MarketingOtp";
import { marketLeadsRedirect } from "./marketingFeature/MarketingRedirect";
import { CheckLimitMFCInitMF } from "./checkLimitMFC/checkLimitMFC_init";
import { CheckLimitMFCOtpMF } from "./checkLimitMFC/checkLimitMFC_Otp";
import { CheckLimitLoadingMF } from "./checkLimitMFC/checkLimitLoading";
import { CheckLimitSuccessMF } from "./checkLimitMFC/checkLimitSuccess";
import { CheckLimitViewDetailMF } from "./checkLimitMFC/checkLimitViewDetail";
import { CheckLimitNoMF } from "./checkLimitMFC/CheckLimitNoMF";
import { CheckLimitInfo } from "./checkLimitMFC/checkLimitInfo";
import { kycDigioResponse } from "./features/kyc/kyc_digio_response";
import { digioAutoPayEntry } from "./features/loanAgreement/digio_autopay_inprogress";
import { digioAutoPayRedirectionMF } from "./features/loanAgreement/autopay_redirection_screen";
import { contactUsCardMF } from "./features/contact_us";
import { CheckLimitAlertModalMF } from "./checkLimitMFC/checkLimit_ErrorModal";
import { partnerCheckLimitMF } from "./partnerWeb_Features/checkLimit";
import { EarningPageMF } from "./partnerWeb_Features/earning";
import { PartnerAuthPage } from "./partnerWeb_Features/partnerAuth";
import { transactionsMFV2 } from "./features/mfPledge/transactionV2";
import { emailStatementMf } from "./features/mfPledge/email_Statement";
import { coBorrowerKYCDigioMf } from "./features/kyc/kyc_co_borrower/co_borrower_kyc_digio_base";
import { digioModelCoBorrowerMF } from "./features/DigioModalCoBorrower";
import { customerPortfolioMF } from "./partnerWeb_Features/customerPortfolio";
import { mandateModal } from "./features/mandateModal";
import { digioDocsModal } from "./features/digiDocsModal";
import { applicationPendingBlockingMf } from "./features/applicationPendingBlocking";
import { checkCustomerEligiblityMF } from "./features/checkCustomerEligiblity";
import { digioAgreementInProgress } from "./features/loanAgreement/digio_agreement_inprogress";
import { digioAgreementFailureMF } from "./features/loanAgreement/digio_agreement_failed";
import { kfsScreenMF } from "./features/kfs_screen";
import { creditLoadingMF } from "./features/creditLoading";
import { nameMismatchMF } from "./features/nameMismatch";
import { checkCibilEligibilityMf } from "./features/checkCibilEligibility";
import { signDeskSign } from "./features/kyc/sign_desk_sign";
import { emailVerifyOtp } from "./features/mfFetch/email_verify_modal";
import { SupportingDocumentMf } from "./features/SupportingDocument";
import { photoMismatchMf } from "./features/photoMismatch";
import { upiInProgressMf } from "./features/payment/upiInProgress";
import { paymentOptionsMf } from "./features/payment/paymentOptions";
import { stateSelectionMF } from "./features/stateSelection";
import { borrowerLandingScreen } from './features/BorrowerLandingScrren';
import { logoutMf } from "./features/logout";
import { bajajKycDigioModal } from "./features/bajajKycDigioModal";
import { bajajKycCoborrowerDigioModal } from "./features/bajajCoborrowerKycDigioModal";
import { failedScreenMf } from "./features/failedScreen";
import { viewPortfolioDetail } from "./features/afterUnlock/view_portfolio";
import { unpledgeFunds } from "./features/afterUnlock/unpledge_funds";
import { unpledgeStatus } from "./features/afterUnlock/unpledge_status";
import { loanForeclosure } from "./features/afterUnlock/loan_foreclose";
import { outstandingDues } from "./features/afterUnlock/outstanding_dues";
import { collateralIntroCardMf } from "./partnerWeb_Features/collateral/collateralIntroCard";
import { collateralDownloadInfo } from "./partnerWeb_Features/collateral/collateralDownloadInfo";
import { previewCollateralMF } from "./partnerWeb_Features/collateral/previewCollateral";
import { collateralLanguageSelectMF } from "./partnerWeb_Features/collateral/collateralLanguageSelect";
import { assetPledge } from "./features/mfPledge/asset_pledge";
import { refreshFetchOtp } from "./features/mfFetch/refresh_fetch";
import { userContext500MF } from "./features/userContext500";
import { paymentInProgressMF } from "./features/payment/paymentInProgress";
import { bajajAgreementStepperMF } from "./features/bajajAgreementStepper";
import { bajajKFSMf } from "./features/bajajKFS";
import { manageLimitLandingMF } from "./features/manageLimitLanding";
import { elevateLandingMF } from "./features/elevateLanding";
import { elevateSwitchingMF } from "./features/elevateSwitching";
import { verifyInterestEnhanceLimitMF } from "./features/mfPledge/verifyInterestEnhanceLimit";
import { preDashboardScreenMF } from "./features/preDashboardScreen";
import { loanRenewalLearnMorePage } from "./features/loanRenewalFlow/loanRenewalLearnMorePage";
import { loanRenewalLandingPage } from "./features/loanRenewalFlow/loanRenewalLearnLandingPage";
import { loanRenewalVerifySummaryPage } from "./features/loanRenewalFlow/loanRenewalVerifySummaryPage";
import { loanRenewalStatusPage } from "./features/loanRenewalFlow/loanRenewalStatusPage";
import { confirmAmountScreenMF } from './features/afterUnlock/confirm_amount';
import { withdrawRequestScreenMF } from './features/afterUnlock/withdraw_request';
import { repaymentChargesDetailMF } from "./features/afterUnlock/repaymentChargesDetails";
import { trackForeClosureMF } from "./features/trackClosureRequest";
import { interestRepaymentDetails } from './features/afterUnlock/interestRepaymentDetails';
import { interestRepaymentLearnMore } from './features/afterUnlock/interestRepaymentLearnMore';
import { cgtcInitMF } from "./cgtcFeature/cgtcInit";
import { cgtcOtpMF } from "./cgtcFeature/cgtcOtp";
import { cgtcProgressMF } from "./cgtcFeature/cgtcInProgress";
import { cgtcSummaryMF } from "./cgtcFeature/cgtcSummary";
import { cgtcNoPortfolioMF } from "./cgtcFeature/cgtcNoPortfolio";
import { captionGainStatementMF } from "./partnerWeb_Features/capitalGainStatement";
import { removePledgeStepsMF } from "./features/afterUnlock/removePledgeSteps";
import { pledgeHistoryMF } from "./features/afterUnlock/pledgeHistory";
import { pledgeDetailsMF } from "./features/afterUnlock/pledgeDetails";
import { shortfallDetailsScreenMF } from './features/afterUnlock/shortfall_details';
import { shortfallInfoScreenMF } from './features/afterUnlock/shortfall_info';
import { shortfallRepayScreenMF } from './features/afterUnlock/shortfall_repay';
import { shortfallRecomendedRepayScreenMF } from './features/afterUnlock/shortfall_recomeded_repay';
import { phonePayPage } from './features/phone_pay_page';
import { kycRedirectMF } from "./features/kyc/kycDirect";
import { asESDocumentsListingMF } from "./features/asESDocumentsListing";
import { asESIndividualDocumentMF } from "./features/asESIndividualDocument";
import { asESDocumentUnderReviewMF } from "./features/asesDocumentUnderReview";
import { asESDocumentsRejectedMF } from "./features/asESDocumentsRejected";
import { asESSampleDocumentViewMF } from "./features/asESSampleViewForm";
import { payoutDetailsScreen } from './partnerWeb_Features/payOutDetails';
import { InterestCalculatorMf } from "./partnerWeb_Features/interest-calculator/";
import { InterestCalculatorAppMf } from './features/interest-calculator-app';
import { kycUrlRedirectMF } from "./features/kycURLRedirect";
import { InterestFilterScreenMf } from './features/interestFilterScreen';
import { customerViewDetailScreen } from './partnerWeb_Features/customerViewDetails';
import { CustomerFilterScreenMf } from './features/customerFilter';
import { ShortfallFilterScreenMf } from './features/shortfallFilter';
import { RenewalFilterScreenMf } from './features/renewalFilter';
import { pendingCustomerViewDetailScreen } from './partnerWeb_Features/pendingCustomerViewDetails';
import { ProductDetailsPage } from './features/productDetailPage';
import { LendingPartnerPage } from './features/lendingPartnerPage';
import { dspKfsMF } from './features/loanAgreement/dspKFS';
import { myLoanDetailsMf } from './features/profile/myLoanProfile';
import { updateLoginScreenMf } from './features/profile/update_loginScreen';
import { updateDetailsScreenMf } from './features/profile/updateDetailsScreen';
import { updateEmailScreenMf } from './features/profile/update_emailScreen';
import { mfCentralEvaluateFundsMF } from "./features/mfFetch/mfcentralFetch/mfCentralEvaluateFunds";
import { mfCentralFetchLandingMf } from "./features/mfFetch/mfcentralFetch/mfCentralFetchLanding";
import { mfCentralFetchAnchorMf } from "./features/mfFetch/mfcentralFetch/mfcFetchAnchor";
import { confirmAndPaymentPageMf } from './features/afterUnlock/confirmAndPaymentPage';
import { mfdShareLinkInitMf } from './features/mfcShareLinkInit';
import { foreclosureScreenMf } from './features/afterUnlock/new_foreclosure';
import { foreclosureReasonScreenMf } from './features/afterUnlock/foreclosureReason';
import { confirmLoanDetailsMf } from './features/afterUnlock/confirmLoanDetailsMf';
import { foreclosureCollateralsDetailsMf } from './features/afterUnlock/foreclosureCollateralDetails';
import { helpAndSupportScreenMf } from './features/profile/helpAndSupport';
import { faqScreenMf } from './features/profile/lmsFaq';
import { faqDetailsScreenMf } from './features/profile/faqDetails';
export const ROUTE_MAP = {
    [ROUTE.PHONE_NUMBER]: phoneNumberMF,
    [ROUTE.OTP_VERIFY]: otpVerifyMF,
    [ROUTE.EMAIL_VERIFY]: emailVerifyMF,
    [ROUTE.ENTER_EMAIL]: emailMF,
    [ROUTE.KYC_PAN_VERIFICATION]: panVerifyMF,
    [ROUTE.PAN_CONFIRM_NAME]: panConfirmMF,
    [ROUTE.MF_FETCH_PORTFOLIO]: checkLimitMF,
    [ROUTE.UPDATE_PHONE_NUMBER]: updateMobileNumberMF,
    [ROUTE.OTP_AUTH_CAS]: otpVerifyAuthCASMF,
    [ROUTE.VERIFICATION_FAILED]: verificationFailedMF,
    [ROUTE.TEST_PAGE]: testPageMF,
    [ROUTE.KYC_AADHAAR_VERIFICATION]: kycAadharVerifyMF,
    [ROUTE.KYC_AADHAAR_VERIFICATION_OTP]: kycAadharOTPVerifyMF,
    [ROUTE.BANK_ACCOUNT_VERIFICATION]: bankAccountVerifyMF,
    [ROUTE.BANK_SELECT]: bankSelectMF,
    [ROUTE.BANK_ACCOUNT_ADD]: bankAccountAddMF,
    [ROUTE.BANK_SEARCH_BRANCH]: bankSearchBranchMF,
    [ROUTE.KYC_SUMMARY]: kycSummaryMf,
    [ROUTE.KYC_STEPPER]: kycStepperMF,
    [ROUTE.KYC_PHOTO_VERIFICATION]: cameraOpenMF,
    [ROUTE.KYC_DIGILOCKER]: kycDigiLockerMF,
    [ROUTE.ALERT_PAGE]: alertMF,
    [ROUTE.CAMERA_CAPTURE]: cameraCaptureMF,
    [ROUTE.SPLASH_SCREEN]: splashScreenMF,
    [ROUTE.MF_PLEDGE_PORTFOLIO]: setCreditLimitMf2,
    [ROUTE.PLEDGE_CONFIRMATION_LOADING]: pledgeConfirmationLoadingMF,
    [ROUTE.PLEDGE_CONFIRMATION]: pledgeConfirmationMFV2,
    [ROUTE.PLEDGE_VERIFY]: pledgeVerifyMF,
    [ROUTE.PLEDGE_LOADING]: pledgeLoadingMF,
    [ROUTE.UNLOCK_SUCCESS]: unlockSuccessMF,
    [ROUTE.MODIFY_LIMIT]: modifyLimitMF,
    [ROUTE.PORTFOLIO]: portfolioMFV2,
    [ROUTE.PLEDGED_AMOUNT]: pledgeAmountMF,
    [ROUTE.MODIFY_PLEDGED_AMOUNT]: modifyPledgeMF,
    [ROUTE.DASHBOARD]: dashboardMF,
    [ROUTE.WITHDRAW_AMOUNT]: withdraw_amountMF,
    [ROUTE.WITHDRAWAL_OTP]: withdrawalOtpMF,
    [ROUTE.WITHDRAWAL_SUCCESS]: withdrawalSuccessMF,
    [ROUTE.REPAYMENT]: repaymentMF,
    [ROUTE.LOAN_REPAYMENT]: loanRepaymentMF,
    [ROUTE.LOAN_WEBVIEW]: loanWebViewMF,
    [ROUTE.LOAN_AUTOPAY]: loanAutoPayMF,
    [ROUTE.LOAN_AGREEMENT]: loanAgreementMF,
    [ROUTE.AGREEMENT_WEBVIEW]: agreementWebViewMF,
    [ROUTE.ACCOUNT_DETAILS]: accountDetailsMF,
    [ROUTE.CONTACT_US]: contactUsMF,
    [ROUTE.MY_PROFILE]: myProfileMF,
    [ROUTE.FAQ]: faqMF,
    [ROUTE.ABOUTUS]: aboutUsMF,
    [ROUTE.FAQ_DETAILS]: faqDetailsMF,
    [ROUTE.CAROUSAL_PAGE]: carousalPageMF,
    [ROUTE.LANDING_PAGE]: landingPageMF,
    [ROUTE.TRANSACTIONS]: transactionsMFV2,
    [ROUTE.PRIVACY_POLICY]: privacyPolicyMF,
    [ROUTE.KYC_ADDITIONAL_DETAILS]: kycAdditionalDetailsMF,
    [ROUTE.UNLOCK_LIMIT_LANDING]: unlockLimitLandingMFV2,
    [ROUTE.DISTRIBUTOR_CLIENT_LIST]: DistributorClientListMF,
    [ROUTE.KYC_DOCUMENT_UPLOAD]: kycDocumentUploadMF,
    [ROUTE.CHECKING_LIMIT]: checkingLimitMf,
    [ROUTE.PORTFOLIO_READONLY]: portfolioReadOnlyMF,
    [ROUTE.VERIFICATION_FAILED_NEW]: verificationFailedMFNew,
    [ROUTE.SET_CREDIT_LIMIT]: setCreditLimitMf,
    [ROUTE.UPDATE_SLIDER_AMOUNT]: updateSliderAmountMF,
    [ROUTE.KYC_DOCUMENT_UPLOAD_POA]: kycDocumentUploadPOAMF,
    [ROUTE.KYC_DOCUMENT_UPLOAD_POI]: kycDocumentUploadPOIMF,
    [ROUTE.LOAN_AGREEMENT_POLLING]: loanAgreementPollingMF,
    [ROUTE.MANAGE_LIMIT]: manageLimitMF,
    [ROUTE.SELECT_SOURCE]: selectSourceMF,
    [ROUTE.SET_CREDIT_LIMIT2]: setCreditLimitMf2,
    [ROUTE.PORTFOLIO_FROM_RTA]: portfoliofromRTAMf,
    [ROUTE.DIST_BANK_ACCOUNT_ADD]: distBankAccountAddMF,
    [ROUTE.DIST_BANK_SEARCH_BRANCH]: distBankSearchBranchMF,
    [ROUTE.DIST_BANK_SELECT]: distBankSelectMF,
    [ROUTE.DISTRIBUTOR_PORTFOLIO]: distributorPortfolioMF,
    [ROUTE.PORTFOLOIO_START]: portfolioStartMF,
    [ROUTE.SELECT_DISTRIBUTOR_PORTFOLIO]: selectDistributorPortfolioMF,
    [ROUTE.INVESTOR]: investorMF,
    [ROUTE.ENTER_NAME]: nameMF,
    [ROUTE.DISTRIBUTOR_CLIENT_LIST]: DistributorClientListMF,
    [ROUTE.DISTRIBUTOR_BASIC_DETAILS_INFO]: distBasicDetailsMF,
    [ROUTE.DETAILS_CONFIRM]: detailsConfirmMF,
    [ROUTE.DISTRIBUTOR_CLIENT_LIST_STEPPER]: DistributorClientListStepperMF,
    [ROUTE.KYC_DOCUMENT_UPLOAD]: kycDocumentUploadMF,
    [ROUTE.DIST_BANK_ACCOUNT_ADD]: distBankAccountAddMF,
    [ROUTE.DIST_BANK_SEARCH_BRANCH]: distBankSearchBranchMF,
    [ROUTE.DIST_BANK_SELECT]: distBankSelectMF,
    [ROUTE.INVESTOR]: investorMF,
    [ROUTE.ENTER_NAME]: nameMF,
    [ROUTE.BASIC_DETAILS_START]: basicDetailsStartMF,
    [ROUTE.INTRO_PAGE]: introPageMF,
    [ROUTE.PARTNER_DASHBOARD]: PartnerWebDashboardPageMF,
    [ROUTE.PARTNER_REFERRED_PARTNER]: PartnerReferredPartnerMF,
    [ROUTE.PARTNER_ACTIVE_CUSTOMER]: PartnerActiveCustomerMF,
    [ROUTE.PARTNER_LEAD]: PartnerLeadsMF,
    [ROUTE.INTRO_PAGE]: introPageMF,
    [ROUTE.PARTNER_LED_JOURNEY]: partnerLedJourney,
    [ROUTE.VOLT_APP]: voltAppMF,
    [ROUTE.DIGIO_AGREEMENT_SIGN]: digioAgreementSignMF,
    [ROUTE.DIGIO_MANDATE_SIGN]: digioMandateSignMF,
    [ROUTE.REGISTER_LEADS]: registerLeadsMF,
    [ROUTE.REGISTER_LEADS_SUCCESS]: registerLeadsSuccessMF,
    [ROUTE.PAYMENT_START]: paymentStart,
    [ROUTE.PAYMENT_CALLBACK]: paymentCallback,
    [ROUTE.KYC_DOCUMENTS_UPLOAD_POI_MANUAL]: kycDocumentUploadPOIManualMF,
    [ROUTE.KYC_DOCUMENTS_UPLOAD_POA_MANUAL]: kycDocumentUploadPOAManualMF,
    [ROUTE.KYC_DOCUMENTS_DIGIO_BASE]: kycDigioMf,
    [ROUTE.KYC_DOCUMENTS_UPLOAD_BASE]: kycDocumentsUploadBaseMF,
    [ROUTE.CO_BORROWER_KYC_DIGIO_BASE]: coBorrowerKYCDigioMf,
    [ROUTE.CO_BORROWER_LANDING]: coBorrowerLandingMF,
    [ROUTE.CO_BORROWER_PAN]: coBorrowerPan,
    [ROUTE.CO_BORROWER_ADDITIONAL_DETAILS]: kycCoBorrowerAdditionalDetailsMF,
    [ROUTE.CO_BORROWER_SUMMARY]: coBorrowerKYCSummaryMf,
    [ROUTE.CO_BORROWER_SUMMARY_CONFIRM]: coBorrowerKYCSummaryConfirmMf,
    [ROUTE.CO_BORROWER_KYC_DOCUMENTS_UPLOAD_BASE]: coBorrowerKYCDocumentsUploadBaseMF,
    [ROUTE.CO_BORROWER_DOCUMENTS_UPLOAD_POA_MANUAL]: coBorrowerDocumentUploadPOAManualMF,
    [ROUTE.CO_BORROWER_DOCUMENTS_UPLOAD_POI_MANUAL]: coBorrowerDocumentUploadPOIManualMF,
    [ROUTE.CO_BORROWER_PAN_CONFIRM_NAME]: coBorrowerPANConfirmMF,
    [ROUTE.DIGIO_MODAL]: digioModel,
    [ROUTE.PAYMENT_LOADER]: paymentLoader,
    [ROUTE.JOINT_HOLDER_NOTIFY]: jointHolderNotifyMf,
    [ROUTE.ASK_MUTUAL_FUND]: askMutualFundMF,
    [ROUTE.NO_MUTUAL_FUND_INSTRUCTION]: noMutualFundMF,
    [ROUTE.ASK_MUTUAL_FUND_OLD]: askMutualFundOldMf,
    [ROUTE.PARTNER_SIGNUP]: PartnerSignUpPage,
    [ROUTE.EMPANEL_SUCCESS_MODAL]: EmpanelSuccessMF,
    [ROUTE.PARTNER_DASHBOARD_V2]: PartnerWebDashboardPageMF,
    [ROUTE.INVITE_CLIENT]: InviteClientMF,
    [ROUTE.PARTNER_LOGOUT]: PartnerLogoutMF,
    [ROUTE.PARTNER_MENU]: PartnerMobSideNav,
    [ROUTE.COLLATERAL]: collateralNav,
    [ROUTE.DEMO_VIDEOS]: demoVideosNav,
    [ROUTE.MY_ACCOUNT]: myAccountMF,
    [ROUTE.PARTNER_VIEW_DETAIL_LEAD]: partnerViewDetailLeads,
    [ROUTE.PLATFORM_DASHBOARD]: platformDashboardMF,
    [ROUTE.PLATFORM_LEADS]: platformLeadsMF,
    [ROUTE.PLATFORM_ACTIVE_CUSTOMERS]: platformActiveCustomersMF,
    [ROUTE.PLATFORM_LINKED_PARTNERS]: platformLinkedPartnersMF,
    [ROUTE.PLATFORM_SIGN_UP]: platformSignupMF,
    [ROUTE.PLATFORM_VIEW_DETAILS]: platformviewDetailsMF,
    [ROUTE.PLATFORM_LOG_OUT]: platformLogOutMF,
    [ROUTE.MARKETING_LEAD]: MarketingLeadsMF,
    [ROUTE.MARKETING_LEAD_OTP]: MarketingLeadOtp,
    [ROUTE.MARKETING_LEAD_REDIRECT]: marketLeadsRedirect,
    [ROUTE.DIGIO_AUTOPAY_INPROGRESS]: digioAutoPayEntry,
    [ROUTE.DIGIO_AUTOPAY_REDIRECTION]: digioAutoPayRedirectionMF,
    [ROUTE.CONTACT_US_CARD]: contactUsCardMF,
    [ROUTE.CHECK_LIMIT_MFC_INIT]: CheckLimitMFCInitMF,
    [ROUTE.CHECK_LIMIT_MFC_OTP]: CheckLimitMFCOtpMF,
    [ROUTE.KYC_DIGIO_RESPONSE]: kycDigioResponse,
    [ROUTE.CHECK_LIMIT_LOADING]: CheckLimitLoadingMF,
    [ROUTE.CHECK_LIMIT_SUCCESS]: CheckLimitSuccessMF,
    [ROUTE.CHECK_LIMIT_VIEW_DETAIL]: CheckLimitViewDetailMF,
    [ROUTE.CHECK_LIMIT_NO_MF]: CheckLimitNoMF,
    [ROUTE.CHECK_LIMIT_INFO]: CheckLimitInfo,
    [ROUTE.CHECK_LIMIT_ALERT_MODAL]: CheckLimitAlertModalMF,
    [ROUTE.PARTNER_CHECK_LIMIT]: partnerCheckLimitMF,
    [ROUTE.EARNING]: EarningPageMF,
    [ROUTE.PARTNER_AUTH]: PartnerAuthPage,
    [ROUTE.EMAIL_STATEMENT]: emailStatementMf,
    [ROUTE.DIGIO_MODAL_CO_BORROWER]: digioModelCoBorrowerMF,
    [ROUTE.PARTNER_CHECK_CUSTOMER_PORFOLIO]: customerPortfolioMF,
    [ROUTE.APPLICATION_PENDING_BLOCKING_SCREEN]: applicationPendingBlockingMf,
    [ROUTE.CHECK_CUSTOMER_ELIGIBILITY]: checkCustomerEligiblityMF,
    [ROUTE.DIGIO_AGREEMENT_INPROGRESS]: digioAgreementInProgress,
    [ROUTE.DIGIO_AGREEMENT_FAILED]: digioAgreementFailureMF,
    [ROUTE.KFS_SCREEN]: kfsScreenMF,
    [ROUTE.CREDIT_LOADING_SCREEN]: creditLoadingMF,
    [ROUTE.NAME_MISMATCH]: nameMismatchMF,
    [ROUTE.CIBIL_CHECK_LOADING_SCREEN]: checkCibilEligibilityMf,
    [ROUTE.SIGN_DESK_ESIGN]: signDeskSign,
    [ROUTE.EMAIL_VERIFY_OTP]: emailVerifyOtp,
    [ROUTE.PARTNER_CHECK_CUSTOMER_PORFOLIO]: customerPortfolioMF,
    [ROUTE.MANDATE_MODAL]: mandateModal,
    [ROUTE.DIGIO_DOC_MODAL]: digioDocsModal,
    [ROUTE.BORROWER_LANDING_SCREEN]: borrowerLandingScreen,
    [ROUTE.LOGOUT_SCREEN]: logoutMf,
    [ROUTE.BAJAJ_DIGIO_KYC_MODAL]: bajajKycDigioModal,
    [ROUTE.PHOTO_MISMATCH]: photoMismatchMf,
    [ROUTE.STATE_SELECTION]: stateSelectionMF,
    [ROUTE.FAILED_SCREEN]: failedScreenMf,
    [ROUTE.VIEW_PORTFOLIO_DETAIL]: viewPortfolioDetail,
    [ROUTE.UNPLDEGE_FUNDS]: unpledgeFunds,
    [ROUTE.UNPLEDGE_STATUS]: unpledgeStatus,
    [ROUTE.FORECLOSURE]: loanForeclosure,
    [ROUTE.OUTSTANDING_DUES]: outstandingDues,
    [ROUTE.BAJAJ_DIGIO_CO_BORROWER_KYC_MODAL]: bajajKycCoborrowerDigioModal,
    [ROUTE.EMAIL_VERIFY_OTP]: emailVerifyOtp,
    [ROUTE.SUPPORTING_DOCUMENT]: SupportingDocumentMf,
    [ROUTE.UPI_IN_PROGRESS]: upiInProgressMf,
    [ROUTE.PAYMENT_OPTIONS]: paymentOptionsMf,
    [ROUTE.COLLATERAL_INTRO_CARD]: collateralIntroCardMf,
    [ROUTE.COLLATERAL_DOWNLOAD_INFO]: collateralDownloadInfo,
    [ROUTE.PREVIEW_COLLATERAL]: previewCollateralMF,
    [ROUTE.COLLATERAL_LANGUAGE_SELECT]: collateralLanguageSelectMF,
    [ROUTE.ASSET_PLEDGE_V2]: assetPledge,
    [ROUTE.OUTSTANDING_DUES]: outstandingDues,
    [ROUTE.REFRESH_FETCH_OTP]: refreshFetchOtp,
    [ROUTE.USER_CONTEXT_500]: userContext500MF,
    [ROUTE.PAYMENT_IN_PROGRESS]: paymentInProgressMF,
    [ROUTE.BAJAJ_AGREEMENT_STEPPER]: bajajAgreementStepperMF,
    [ROUTE.BAJAJ_KFS]: bajajKFSMf,
    [ROUTE.MANAGE_LIMIT_LANDING]: manageLimitLandingMF,
    [ROUTE.ELEVATE_LANDING]: elevateLandingMF,
    [ROUTE.ELEVATE_SWITCHING]: elevateSwitchingMF,
    [ROUTE.VERIFY_INTEREST_CHARGES_ENHANCE_LIMIT]: verifyInterestEnhanceLimitMF,
    [ROUTE.PRE_DASHBOARD_SCREEN]: preDashboardScreenMF,
    [ROUTE.LOAN_RENEWAL_LEARN_MORE_PAGE]: loanRenewalLearnMorePage,
    [ROUTE.LOAN_RENEWAL_LANDING_PAGE]: loanRenewalLandingPage,
    [ROUTE.LOAN_RENEWAL_VERIFY_SUMMARY_PAGE]: loanRenewalVerifySummaryPage,
    [ROUTE.LOAN_RENEWAL_STATUS_PAGE]: loanRenewalStatusPage,
    [ROUTE.CONFIRM_AMOUNT]: confirmAmountScreenMF,
    [ROUTE.WITHDRAW_REQUEST]: withdrawRequestScreenMF,
    [ROUTE.REPAYMENT_CHARGES_DETAILS_PAGE]: repaymentChargesDetailMF,
    [ROUTE.TRACK_FORECLOSURE]: trackForeClosureMF,
    [ROUTE.INTEREST_REPAYMENT_DETAILS]: interestRepaymentDetails,
    [ROUTE.INTEREST_REPAYMENT_LEARN_MORE]: interestRepaymentLearnMore,
    [ROUTE.CGTC_INIT]: cgtcInitMF,
    [ROUTE.CGTC_OTP]: cgtcOtpMF,
    [ROUTE.CGTC_PROGRESS]: cgtcProgressMF,
    [ROUTE.CGTC_SUMMARY]: cgtcSummaryMF,
    [ROUTE.CGTC_NO_PORTFOLIO]: cgtcNoPortfolioMF,
    [ROUTE.PARTNER_CAPITAL_GAIN]: captionGainStatementMF,
    [ROUTE.REMOVE_PLEDGE_STEPS]: removePledgeStepsMF,
    [ROUTE.PLEDGE_HISTORY]: pledgeHistoryMF,
    [ROUTE.PLEDGE_DETAILS]: pledgeDetailsMF,
    [ROUTE.SHORTFALL_DETAILS_SCREEN]: shortfallDetailsScreenMF,
    [ROUTE.SHORTFALL_INFO_SCREEN]: shortfallInfoScreenMF,
    [ROUTE.SHORTFALL_REPAY_SCREEN]: shortfallRepayScreenMF,
    [ROUTE.SHORTFALL_RECOMENDED_REPAY_SCREEN]: shortfallRecomendedRepayScreenMF,
    [ROUTE.PHONE_PAY_PAGE]: phonePayPage,
    [ROUTE.KYC_DIRECT]: kycRedirectMF,
    [ROUTE.AS_ES_DOCUMENTS_LISTING]: asESDocumentsListingMF,
    [ROUTE.AS_ES_INDIVIDUAL_DOCUMENT]: asESIndividualDocumentMF,
    [ROUTE.AS_ES_DOCUMENT_IN_REVIEW]: asESDocumentUnderReviewMF,
    [ROUTE.AS_ES_DOCUMENT_REJECTED]: asESDocumentsRejectedMF,
    [ROUTE.AS_ES_SAMPLE_DOCUMENT_VIEW]: asESSampleDocumentViewMF,
    [ROUTE.PAYOUT_DETAILS_SCREEN]: payoutDetailsScreen,
    [ROUTE.INTEREST_CALCULATOR]: InterestCalculatorMf,
    [ROUTE.INTEREST_CALCULATOR_APP]: InterestCalculatorAppMf,
    [ROUTE.KYC_URL_REDIRECT]: kycUrlRedirectMF,
    [ROUTE.INTEREST_FILTER_SCREEN]: InterestFilterScreenMf,
    [ROUTE.CUSTOMER_VIEW_DETAILS_SCREEN]: customerViewDetailScreen,
    [ROUTE.CUSTOMER_FILTER_SCREEN]: CustomerFilterScreenMf,
    [ROUTE.SHORTFALL_FILTER_SCREEN]: ShortfallFilterScreenMf,
    [ROUTE.RENEWAL_FILTER_SCREEN]: RenewalFilterScreenMf,
    [ROUTE.PENDING_CUSTOMER_VIEW_DETAILS_SCREEN]: pendingCustomerViewDetailScreen,
    [ROUTE.PRODUCT_DETAILS_PAGE_MF]: ProductDetailsPage,
    [ROUTE.LENDING_PARTNER_PAGE_MF]: LendingPartnerPage,
    [ROUTE.DSP_KFS]: dspKfsMF,
    [ROUTE.MY_LOAN_PROFILE]: myLoanDetailsMf,
    [ROUTE.UPDATE_LOGIN_SCREEN]: updateLoginScreenMf,
    [ROUTE.UPDATE_EMAIL_SCREEN]: updateEmailScreenMf,
    [ROUTE.UPDATE_DETAILS_SCREEN]: updateDetailsScreenMf,
    [ROUTE.MFC_FETCH_EVALUTE_FUNDS]: mfCentralEvaluateFundsMF,
    [ROUTE.MFC_FETCH_LANDING]: mfCentralFetchLandingMf,
    [ROUTE.MFC_FETCH_ANCHOR]: mfCentralFetchAnchorMf,
    [ROUTE.CONFIRM_AND_PAYMENT]: confirmAndPaymentPageMf,
    [ROUTE.MFD_SHARE_LINK_INIT]: mfdShareLinkInitMf,
    [ROUTE.FORECLOSURE_NEW]: foreclosureScreenMf,
    [ROUTE.FORECLOSURE_REASON]: foreclosureReasonScreenMf,
    [ROUTE.CONFIRM_LOAN_DETAILS]: confirmLoanDetailsMf,
    [ROUTE.FORECLOSURE_COLLATERAL_DETAILS]: foreclosureCollateralsDetailsMf,
    [ROUTE.HELP_AND_SUPPORT_SCREEN]: helpAndSupportScreenMf,
    [ROUTE.FAQ_SCREEN]: faqScreenMf,
    [ROUTE.FAQ_DETAILS_SCREEN]: faqDetailsScreenMf,
};
